var _linearGradient, _clipPath, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdobexd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83,
    height: 20,
    role: "img",
    "aria-label": "Adobe XD",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Adobe XD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 83,
    height: 20,
    fill: "#ff61f6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,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"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 505,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 550
  }, "Adobe XD"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 550
  }, "Adobe XD"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobexd);
export default __webpack_public_path__ + "static/media/adobexd.9f23448211d9c5d22512e13bba37cc89.svg";
export { ForwardRef as ReactComponent };